import React, { useState } from "react";
import { riskForm } from "./risk_form";
import { useTranslation } from "react-i18next";
import { Box, Divider, Tab, Tabs } from "@mui/material";
import { RiskQuestion } from "./Components/RiskQuestion";

export const RiskForm = ({ formValues, handleChange }) => {
  console.log("RiskForm", formValues.risk_form_value, formValues);
  const { t } = useTranslation("main");
  const [activeStep, setActiveStep] = useState(0);
  const handleStep = (step) => () => {
    setActiveStep(step);
  };

  const activePhase = Object.values(riskForm)[activeStep];

  const handleChangeRiskForm = (key) => (newValue) => {
    const calculateRiskFormLevelSum = () => {
      return Object.keys(formValues)
        .filter((key) => key.startsWith("risk_form_level_"))
        .reduce(
          (sum, k) => sum + (k === key ? newValue : formValues[k] || 0),
          0
        );

      // .reduce((sum, key) => sum + (formValues[key] || 0), 0);
    };

    handleChange(key)(newValue);
    handleChange("risk_form_value")(calculateRiskFormLevelSum());
  };

  return (
    <Box>
      <Tabs
        value={activeStep}
        onChange={(_, newValue) => handleStep(newValue)()}
        variant="scrollable"
      >
        {Object.keys(riskForm).map((phase, index) => {
          return <Tab key={phase} label={t(phase)} value={index} />;
        })}
      </Tabs>
      <Box
        sx={{
          p: 2,
          display: "flex",
          flexDirection: "column",
          gap: "2rem",
          borderRadius: "8px",
          border: "1px solid lightgrey",
        }}
      >
        {activePhase.map((question, index) => (
          <>
            {index !== 0 && <Divider />}
            <RiskQuestion
              key={question.key}
              value={
                formValues[`risk_form_level_${question.key.split("risk_")[1]}`]
              }
              question={question}
              handleChange={handleChangeRiskForm}
            />
          </>
        ))}
      </Box>
    </Box>
  );
};
